import { COLORS } from './constants';
import { getCircleBackground } from './icon';
export default () => [getCircleBackground(COLORS.neutral)];
//# sourceMappingURL=defaultProductIcon.js.map